import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  /**
   *
   */
  constructor(private authService: AuthService, private router: Router) {}

  /**
   * 
   * @param next 
   * @param state 
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {      
      const ret = this.authService.canAccessRoute(next.url);
      if (!ret) {
        this.router.navigate(['/login'], {
          queryParams: {
            return: state.url
          }
        });
      }
      return ret;
  }
  
}
